import React from 'react'
import { Container } from '../../components/Container'
import { BackgroundSection } from './Background'

export const ChooseSafternetWrapper = () => (
  <Container px={{ _: 0 }}>
    <BackgroundSection />
  </Container>
)
